export const learningStyleContent = {
    visual: {
        description: "Visual learners can be divided into the more specific types. Both take in information by having time to process what they see, however memorization and understanding is triggered in vastly different ways.",
        learner_types: [
            {
                type: "Visual-linguistic",
                description: "Best process information through writing and reading, thrive in lessons presented in text-driven formats, and are quite keen on taking notes."
            },
            {
                type: "Visual-spatial",
                description: "Words are not their forte; they instead prefer images, infographics, and artistic renderings. They memorize places, sights, and locations by taking a mental picture."
            }
        ],
        tips: [
            "Build lessons and assignments around visual aides",
            "Use attachments such as maps, itineraries, articles, and photos",
            "Take notes – whether that be text, drawing, or charts",
            "Go through notes and ask questions – then modify as needed",
            "Pay attention to pauses in a lesson",
            "Minimize audible or visual distractions",
            "Draw sketches/take notes in the margins"
        ]
    },
    auditory: {
        description: "Auditory learners gain from, enjoy, and practice exactly what the name suggests. They often talk out loud to themselves, a process that helps them process thoughts and ideas and gives them a chance to clear their mind.",
        learner_types: [
            {
                type: "Auditory Learner",
                description: "When reading, auditory learners are known to recite text out loud. If in a location where that is not appropriate or doable, they'll move their lips as they read."
            }
        ],
        tips: [
            "Begin lessons and presentations with an overview of the process",
            "Finish a document or presentation with a summary",
            "Employing the Socratic method of lecturing",
            "Participate in inclusive activities",
            "Engage in recitation activities"
        ]
    },
    kinesthetic: {
        description: "Kinesthetic learners are a physical bunch. They like to touch, taste, smell, and be active within the lesson in order to best process and remember what they are learning.",
        learner_types: [
            {
                type: "Kinesthetic (movement)",
                description: "All about getting involved. This type wants a deep dive where they are fully engaged with the material and can learn from the experience."
            },
            {
                type: "Tactile (touch)",
                description: "Similar breed but it's not just about motion. They often opt to write down what they learn just to feel their hand move, and often want to peruse an overview before specifics."
            }
        ],
        tips: [
            "Use hands-on activities",
            "Engage in physical activities during lessons",
            "Use tactile aids such as tactile diagrams or tactile writing",
            "Use movement breaks to refresh and refocus",
            "Use physical gestures to emphasize points",
            "Use physical objects to represent concepts",
            "Use physical interactions to reinforce learning"
        ]
    }
}; 